import { FC, useMemo } from 'react';
import { List, ListItem, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import { WarningType } from '@interfaces/highRiskSupplements';
import { RiskSupplementWarningType } from '@models/riskSupplementWarningType';
import useWarningTypes from '@store/hooks/useWarningTypes';

import WarningTypeItem from '../WarningTypeItem/WarningTypeItem';

import './style.scss';

interface IProps {
  data: RiskSupplementWarningType;
  showTooltip?: boolean;
}

const WarningTypeItemWithTooltip: FC<IProps> = ({ data, showTooltip = true }): JSX.Element => {
  const { descriptionFragments } = useWarningTypes();

  const hasDescription = useMemo(
    () =>
      Boolean(
        descriptionFragments.get(data.normalizedName) &&
          descriptionFragments.get(data.normalizedName)?.length,
      ),
    [descriptionFragments, data],
  );

  const tooltipElement = useMemo(() => {
    if (!hasDescription) {
      return null;
    }
    if (data.id !== WarningType.Regulatory) {
      return (
        <Typography className="warning-type-tooltip__text">
          {descriptionFragments.get(data.normalizedName)?.join(' ')}
        </Typography>
      );
    }
    return (
      <List className="warning-type-tooltip__list">
        {descriptionFragments
          .get(data.normalizedName)
          ?.map(fragment => (
            <ListItem className="warning-type-tooltip__list-item">{fragment}</ListItem>
          ))}
      </List>
    );
  }, [descriptionFragments, data, hasDescription]);

  return (
    <Tooltip
      placement="bottom-start"
      classes={{ tooltip: 'warning-type-tooltip__tooltip' }}
      title={tooltipElement}
    >
      <div>
        <WarningTypeItem data={data} />
      </div>
    </Tooltip>
  );
};

export default WarningTypeItemWithTooltip;
